module.exports = __webpack_public_path__ + "img/RM.2950a449.svg";